module.exports = __webpack_public_path__ + "static/media/about-55-paris.e2afe3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-55-paris.jpg
// module id = 1194
// module chunks = 37